import { Component, DestroyRef, ElementRef, inject, Input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BaseComponent } from "../../base/base.component";

@Component({
  standalone: false,
  selector: "app-base-modal",
  templateUrl: "./base-modal.component.html",
  styleUrls: ["./base-modal.component.scss"],
})
export class BaseModalComponent extends BaseComponent {
  @Input() showClose: boolean = true;
  @Input() remainBlur = false;
  @Input() titleModal = "";
  @Input() backgroundColor = false;

  private destroyRef = inject(DestroyRef);
  private elRef = inject(ElementRef);

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    const isInsideModal = !!this.elRef.nativeElement.closest("ion-modal");
    if (isInsideModal) {
      this.system.closeModal$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.closeModal();
      });
    }

    if (this.shared.web && this.router.url !== "/tabs/cart") {
      setTimeout(() => {
        this.system.blur = true;
      }, 100);
    } else {
      this.system.blur = false;
    }
  }

  async closeModal(role?: string, data?: any, action?: Function) {
    if (this.remainBlur) {
      this.system.blur = true;
    } else {
      this.system.blur = false;
    }

    if (action) {
      action();
    }

    const topModal = await this.system.modalCtrl.getTop();
    if (topModal) {
      try {
        await this.system.modalCtrl.dismiss(data, role);
      } catch (error) {
        console.error("Erro ao tentar fechar o modal:", error);
      }
    }
  }
}
